import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Modal from 'react-bootstrap/Modal';

function CartInfoTodayInfoModal({
  show,
  handleClose
}: {
  show: boolean,
  handleClose: () => void,
}) {

  return (
    <Modal show={show} onHide={handleClose} size='lg'>
      <Modal.Header closeButton style={{ borderBottom: 'none' }}></Modal.Header>
      <Modal.Body>
        <Container>
          <Row>
            <Col className='mb-4'>
              <div className="cart-tooltip-text">
                <strong>Installation when adding new service:</strong>
                <ul style={{marginBottom: '20px'}}>
                  <li>In most instances, installation is waived with new services receiving a bundle or promotion.</li>
                  <li>Installation fees apply when adding services that do not qualify for a bundle or promotion.</li>
                  <li>When an address is eligible for self-install, free install options are available. If professional installation is chosen, an installation fee will apply.</li>
                  <li>For bundles containing security, an installation fee is required.</li>
                </ul>
                <strong>One-time Charges when Upgrading Equipment:</strong> If you are an existing Comporium customer and you are upgrading/buying equipment (like security devices for example), your account will be billed for this equipment. Your one-time charges line will equal $0 because we are not collecting this payment from you today.<br /><br />
                <strong>Upgrading Current Service:</strong> Installation may apply when upgrading services if professional installation is required. Installation may be waived with qualifying bundles or promotions.<br /><br />
                Security deposits may apply for new services or upgrades and are determined at checkout. Any customer new to Comporium is subject to credit check and security deposits could apply. For current customers that are upgrading or adding services, credit check and deposits are determined based on the payment history of the account.
              </div>
            </Col>
          </Row>
        </Container>
      </Modal.Body>
    </Modal>
  );
}

export default CartInfoTodayInfoModal;